import LtableTop from './src/main'

/* istanbul ignore next */
LtableTop.install = function(Vue) {
  Vue.component(LtableTop.name, LtableTop)
}

export default LtableTop
